import H from 'constants/httpMethod.const';
import logger from 'utils/logger.util';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

const L = logger('beSalonBusinessInfoAndHours'); // eslint-disable-line no-unused-vars

const fromDtoToSalonInfoHours = (dto) => ({
  monOpen: dto?.results?.mon_open,
  tueOpen: dto?.results?.tue_open,
  wedOpen: dto?.results?.wed_open,
  thuOpen: dto?.results?.thu_open,
  friOpen: dto?.results?.fri_open,
  satOpen: dto?.results?.sat_open,
  sunOpen: dto?.results?.sun_open,
  monOpenTime: dto?.results?.mon_open_time,
  monCloseTime: dto?.results?.mon_close_time,
  tueOpenTime: dto?.results?.tue_open_time,
  tueCloseTime: dto?.results?.tue_close_time,
  wedOpenTime: dto?.results?.wed_open_time,
  wedCloseTime: dto?.results?.wed_close_time,
  thuOpenTime: dto?.results?.thu_open_time,
  thuCloseTime: dto?.results?.thu_close_time,
  friOpenTime: dto?.results?.fri_open_time,
  friCloseTime: dto?.results?.fri_close_time,
  satOpenTime: dto?.results?.sat_open_time,
  satCloseTime: dto?.results?.sat_close_time,
  sunOpenTime: dto?.results?.sun_open_time,
  sunCloseTime: dto?.results?.sun_close_time,
  name: dto?.results?.name,
  addressLineFirst: dto?.results?.address_line_1,
  addressLineNext: dto?.results?.address_line_2,
  email: dto?.results?.email,
  city: dto?.results?.city,
  phone: dto?.results?.phone,
  postcode: dto?.results?.postcode,
  vatNumber: dto?.results?.vat_number,
  isVatRegistered: dto?.results?.is_vat_registered,
  countryCode: dto?.results?.country.code,
});

const fromSalonInfoHoursToDto = (item) => ({
  mon_open: item?.monOpen,
  tue_open: item?.tueOpen,
  wed_open: item?.wedOpen,
  thu_open: item?.thuOpen,
  fri_open: item?.friOpen,
  sat_open: item?.satOpen,
  sun_open: item?.sunOpen,
  mon_open_time: item?.monOpenTime,
  mon_close_time: item?.monCloseTime,
  tue_open_time: item?.tueOpenTime,
  tue_close_time: item?.tueCloseTime,
  wed_open_time: item?.wedOpenTime,
  wed_close_time: item?.wedCloseTime,
  thu_open_time: item?.thuOpenTime,
  thu_close_time: item?.thuCloseTime,
  fri_open_time: item?.friOpenTime,
  fri_close_time: item?.friCloseTime,
  sat_open_time: item?.satOpenTime,
  sat_close_time: item?.satCloseTime,
  sun_open_time: item?.sunOpenTime,
  sun_close_time: item?.sunCloseTime,
  name: item?.name,
  address_line_1: item?.addressLineFirst,
  address_line_2: item?.addressLineNext,
  email: item?.email,
  city: item?.city,
  phone: item?.phone,
  postcode: item?.postcode,
  vat_number: item?.vatNumber,
  is_vat_registered: item?.isVatRegistered,
  country: item?.countryCode ? { code: item.countryCode } : undefined,
});

export const ibeSalonBusinessInfoAndHoursRead = actionEndpointBe(
  'ibeSalonBusinessInfoAndHoursRead',
  H.get,
  'salon/business-info-and-opening-hours/:salonId/',
  (options) => ({
    ...options,
    inert: true,
    fromDto: fromDtoToSalonInfoHours,
  }),
);

export const ibeSalonBusinessInfoAndHoursUpdate = actionEndpointBe(
  'ibeSalonBusinessInfoAndHoursUpdate',
  H.patch,
  'salon/business-info-and-opening-hours/:salonId/',
  (options, extra) => ({
    ...options,
    inert: true,
    fromDto: fromDtoToSalonInfoHours,
    toDto: fromSalonInfoHoursToDto,
    data: extra?.data,
  }),
);
